module.exports = __webpack_public_path__ + "img/ebay.af30632e.jpg";